import { render } from "./Template.vue?vue&type=template&id=45c11650&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-45c11650"

export default script